import React from 'react'
import classNames from 'classnames'
import { AngelPlayer, AngelPlayerProps } from '@/organisms/AngelPlayer'

export const FullScreenAngelPlayer: React.VFC<AngelPlayerProps> = ({ asset, children, ...props }) => {
  if (!asset) {
    return (
      <div
        aria-label="Loading Video..."
        className={classNames(
          'w-full aspect-w-16 aspect-h-9 lg:aspect-h-unset lg:aspect-w-unset lg:h-[60vh] bg-black',
          props.className,
        )}
      />
    )
  }

  return (
    <AngelPlayer asset={asset} {...props}>
      {children}
    </AngelPlayer>
  )
}
